<template>
  <span class="modalcomponent">
    <a-modal v-model="modalVisible" :title="title" :style="styleModal" :width="width" :zIndex="zIndex" :maskClosable="maskClosable" onOk="handleOk" :footer="$slots.buttons || null">      
      <slot></slot>
    </a-modal>
  </span>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Title',
        },
        width: {
            type: String,
            default: '100%',
        },
        zIndex: {
            type: Number,
            default: 1000,
        },
        styleModal: {
            type: String,
            default: '',
        },
        maskClosable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            modalVisible: this.visible,
        };
    },
    methods: {
        showModal() {
            this.modalVisible = true;
        },
        handleCancel() {            
            this.modalVisible = false;
        },
    }
};
</script>